<template>
  <div class="page main-background">
    <!-- <div v-if="!loading">
      <div class="error-message" v-if="errorMessage">
        <h3 class="loading-title text-color">{{ errorMessage }}</h3>
      </div>
      <div v-if="!errorMessage && freewayTolls">
        <h2 class="page-title text-color">
          نتیجه استعلام عوارض آزادراه
        </h2>

        <div class="text-color border-color background-color card">
          <div class="header-item">
            <div class="header-item-title">
              <h3>تعداد استعلام</h3>
            </div>
            <div class="header-item-value">
              <h3>{{ (freewayTolls.Details ? freewayTolls.Details.length : 0) | separator | persian }} عدد</h3>
            </div>
          </div>
          <div class="header-item">
            <div class="header-item-title">
              <h3>جمع کل مبلغ</h3>
            </div>
            <div class="header-item-value">
              <h3>{{ freewayTolls.TotalAmount | separator | persian }} ریال</h3>
            </div>
          </div>

          <div v-if="freewayTolls.Details && freewayTolls.Details.length > 0" style="text-align: center; margin-top: 10px">
            <a target="_blank" :href="`${baseUrl}/payment/freewayTolls?token=${getToken}&carId=${carId}`" type="button" class="payment-button" >پرداخت دسته جمعی عوارض آزادراه</a>
          </div>
        </div>
        <div v-if="freewayTolls.Details">
          <div v-for="item in freewayTolls.Details" :key="item.BillId">
            <div class="detail-item text-color border-color background-color">
              <div class="detail-item-header">
                تاریخ: {{ item.PersianDate | persian }}
              </div>
              <div class="detail-item-body">
                <div>
                  مبلغ:
                  {{ item.Amount | separator | persian }} ریال
                </div>
              </div>
              <div>
                <a target="_blank" :href="`${baseUrl}/payment/freewayTolls?token=${getToken}&carId=${carId}&billId=${item.BillId}`" type="button" class="payment-button">پرداخت</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="alert-bg">
      <div class="alert-box">
        <img src="../../assets/img/logo-bg1.png" width="200px">
        <h3 class="textCenter">با عرض پوزش، سرویس‌های عوارض آزادراه در حال حاضر غیرفعال هستند.</h3>
      </div>
    </div>
    <div v-if="loading">
      <h3 class="loading-title text-color">
        در حال دریافت اطلاعات عوارض آزادراه برای خودروی شما، لطفا شکیبا باشید.
      </h3>
      <loader />
    </div>
  </div>
</template>

<script>
import api, { BaseUrl } from "../../service";
import loader from "../../components/inquiry/Loader";
import { mapGetters } from "vuex";

export default {
  name: "freeway-tolls",
  components: {
    loader,
  },
  props: {
    carId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      errorMessage: null,
      loading: false,
      freewayTolls: null,
      baseUrl: BaseUrl,
    };
  },
  mounted() {
    this.loading = true;
    api
      .getFreewayTolls(this.carId)
      .then((response) => {
        if (response.data && response.data.Status === 200) {
          this.freewayTolls = response.data.Data;
        } else {
          if (
            response.data &&
            response.data.Messages &&
            response.data.Messages.length > 0
          ) {
            this.errorMessage = response.data.Messages[0];
          }
        }
      })
      .catch(() => {
        this.errorMessage = "متاسفانه خطای فنی رخ داده است؛ لطفا دوباره امتحان کنید.";
      })
      .finally(() => {
        this.loading = false;
      });
  },
  computed: {
    ...mapGetters(["getToken"]),
  },
};
</script>

<style scoped>
/* .page {
  padding-bottom: 20px;
  display: flow-root;
} */

.page-title {
  padding: 20px 12px 8px 12px;
}

.card {
  border: solid 1px;
  margin: 10px 10px 0 10px;
  border-radius: 5px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  border-bottom: solid 3px #09389f !important;
  position: relative;
}

.detail-item {
  border: solid 1px;
  margin: 10px 10px 0 10px;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  line-height: 27px;
}

.detail-item-header {
  background-color: #09389f;
  padding: 4px 12px;
  color: white;
}

.detail-item-body {
  padding: 8px 12px;
}

.loading-title {
  padding: 50px 15px 0;
  text-align: center;
}

.header-item {
  display: flex;
  line-height: 40px;
}

.header-item-title {
  flex: 1;
}

.payment-button {
  border: solid 1px #00c11b;
  background-color: #00c11b;
  padding: 4px 20px;
  color: white;
  border-radius: 5px;
  margin: 10px 8px;
}
</style>
